import { Account } from 'src/api/@generated/backend-api';

import { RootState } from 'src/state/types';
import { getOrThrow } from 'src/utils/type-utils';

export const selectSelectedAccount = (state: RootState): Account | undefined => state.account.selectedAccount;

export const selectSelectedAccountOrThrow = (state: RootState): Account =>
  getOrThrow(selectSelectedAccount(state), 'Invalid state. Account must be selected.');
